/* eslint-disable */
import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import { useTranslation } from "react-i18next";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { getData, postData, putData } from "utils/Gateway";

const SaveChapterPopup = ({
  selectedChapterId,
  setSelectedChapterId,
  afterPopupClose,
}) => {
  const params = useParams();
  const token = localStorage.getItem("token");
  const { t } = useTranslation();

  const [memberList, setmemberList] = useState([]);
  const [code, setcode] = useState("");
  const [title, settitle] = useState("");
  const [rank, setrank] = useState("");
  const [details, setdetails] = useState("");
  const [memberValue, setmemberValue] = useState(null);
  const [memberIds, setmemberIds] = useState([]);
  const [isSaving, setisSaving] = useState(false);
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};

    if (memberIds.length === 0) {
      newErrors.members = t(
        "Please select at least one member for this chapter."
      );
    }
    if (!code.trim()) {
      newErrors.code = t("A unique code for the chapter is required.");
    }
    if (!title.trim()) {
      newErrors.title = t("Please enter a title for the chapter.");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const getAllMemberList = async () => {
    try {
      let requestURL =
        url.API_BASE_URL +
        url.API_GET_COURSE_MEMBER_LIST_OPTIONS +
        `?token=${token}&courseid=${params.id}`;
      const response = await getData(requestURL);
      if (response.status) {
        setmemberList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const memberSelectionHandler = (val) => {
    setmemberValue(val);
    setmemberIds(val.map((item) => item.value));
  };

  const getChapterDetails = async () => {
    try {
      let requestURL =
        url.API_BASE_URL +
        url.API_GET_COURSE_CHAPTER_DETAILS +
        `/${selectedChapterId}?token=${token}`;
      const response = await getData(requestURL);
      if (response.status) {
        setcode(response.data.code);
        settitle(response.data.title);
        setrank(response.data.rank);
        setdetails(response.data.description);
        memberSelectionHandler(response.data.membervalues);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const saveChapterHandler = async () => {
    if (!validateForm()) {
      return;
    }
    try {
      setisSaving(true);
      let chapterData = {
        course: params.id,
        code,
        title,
        rank,
        description: details,
        members: memberIds,
      };

      let requestURL = url.API_BASE_URL;
      let response = {};

      if (selectedChapterId) {
        requestURL +=
          url.API_UPDATE_COURSE_CHAPTER +
          `/${selectedChapterId}?token=${token}`;
        response = await putData(requestURL, chapterData);
      } else {
        requestURL += url.API_ADD_NEW_COURSE_CHAPTER + `?token=${token}`;
        response = await postData(requestURL, chapterData);
      }

      setisSaving(false);

      if (response.status) {
        resetHandler();
        afterPopupClose();
        window.bootstrap.Offcanvas.getInstance(
          document.querySelector("#addUpdateChapterOffCanvas")
        ).hide();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const resetHandler = () => {
    setcode("");
    settitle("");
    setrank("");
    setdetails("");
    setmemberValue(null);
    setmemberIds([]);
    setSelectedChapterId(null);
    setErrors({});
  };

  useEffect(() => {
    if (selectedChapterId) {
      getChapterDetails();
    }
  }, [selectedChapterId]);

  useEffect(() => {
    if (params.id) {
      getAllMemberList();
    }
  }, [params.id]);

  const customStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errors.members ? "#dc3545" : "#ced4da",
      "&:hover": {
        borderColor: errors.members ? "#dc3545" : "#ced4da",
      },
      borderRadius: "7px",
      padding: "3px",
      minHeight: "40px",
      boxShadow: "none",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "0.875rem",
      color: "#6c757d",
    }),
    input: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
  };

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0"
      tabIndex="-1"
      id="addUpdateChapterOffCanvas"
      aria-labelledby="offcanvasLabelDetailsLabel"
    >
      <div className="offcanvas-header p-4 pb-0">
        <h3 className="offcanvas-title" id="offcanvasLabelDetailsLabel">
          {selectedChapterId ? t("Edit Chapter") : t("Add New Chapter")}
        </h3>
        <button
          type="button"
          className="btn-close p-0 bg-gray-200 rounded-circle shadow-none m-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div className="offcanvas-body p-4">
        <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm">
          <form
            onSubmit={(e) => e.preventDefault()}
            className="d-flex flex-column h-100"
          >
            <div className="form-group mb-4">
              <label
                htmlFor="selectMembers"
                className="d-block fs-sm fw-semibold mb-2"
              >
                {t("Select Members")} <span className="text-danger">*</span>
              </label>
              <Select
                id="selectMembers"
                isMulti
                styles={customStyles}
                placeholder={t(
                  "Search and select members to add to this chapter"
                )}
                options={memberList}
                value={memberValue}
                onChange={(val) => {
                  memberSelectionHandler(val);
                  if (errors.members) {
                    setErrors((prev) => ({ ...prev, members: "" }));
                  }
                }}
              />
              {errors.members && (
                <div className="invalid-feedback d-block">{errors.members}</div>
              )}
            </div>

            <div className="fields-container flex-fill">
              <div className="form-group mb-4">
                <label
                  htmlFor="chapterCode"
                  className="d-block fs-sm fw-semibold mb-2"
                >
                  {t("Code")} <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="chapterCode"
                  className={`form-control fs-sm shadow-none ${
                    errors.code ? "is-invalid" : "border border-gray-300"
                  }`}
                  placeholder={t("e.g., CH-01")}
                  value={code}
                  onChange={(e) => {
                    setcode(e.target.value);
                    if (errors.code) {
                      setErrors((prev) => ({ ...prev, code: "" }));
                    }
                  }}
                />
                {errors.code && (
                  <div className="invalid-feedback d-block">{errors.code}</div>
                )}
              </div>

              <div className="form-group mb-4">
                <label
                  htmlFor="chapterTitle"
                  className="d-block fs-sm fw-semibold mb-2"
                >
                  {t("Title")} <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="chapterTitle"
                  className={`form-control fs-sm shadow-none ${
                    errors.title ? "is-invalid" : "border border-gray-300"
                  }`}
                  placeholder={t("e.g., Introduction to the Course")}
                  value={title}
                  onChange={(e) => {
                    settitle(e.target.value);
                    if (errors.title) {
                      setErrors((prev) => ({ ...prev, title: "" }));
                    }
                  }}
                />
                {errors.title && (
                  <div className="invalid-feedback d-block">{errors.title}</div>
                )}
              </div>

              <div className="form-group mb-4">
                <label
                  htmlFor="chapterRank"
                  className="d-block fs-sm fw-semibold mb-2"
                >
                  {t("Rank")}
                </label>
                <input
                  type="number"
                  min={1}
                  id="chapterRank"
                  className="form-control fs-sm shadow-none border border-gray-300"
                  placeholder={t("e.g., 1 (determines chapter order)")}
                  value={rank}
                  onChange={(e) => {
                    setrank(e.target.value);
                  }}
                />
              </div>

              <div className="form-group mb-4">
                <label
                  htmlFor="chapterDescription"
                  className="d-block fs-sm fw-semibold mb-2"
                >
                  {t("Description")}
                </label>
                <textarea
                  name="chapterDescription"
                  id="chapterDescription"
                  cols="30"
                  rows="4"
                  className="form-control border border-gray-300"
                  placeholder={t(
                    "Provide a brief summary of what this chapter covers."
                  )}
                  value={details}
                  onChange={(e) => {
                    setdetails(e.target.value);
                  }}
                ></textarea>
              </div>
            </div>
            <div className="action d-flex justify-content-between gap-3">
              <button
                type="button"
                className="btn btn-outline-primary"
                data-bs-dismiss="offcanvas"
                onClick={resetHandler}
              >
                {t("Cancel")}
              </button>
              <button
                onClick={saveChapterHandler}
                type="button"
                className="btn btn-primary"
                disabled={isSaving}
                style={{
                  cursor: isSaving ? "not-allowed" : "pointer",
                }}
              >
                {t("Save")}
                {isSaving && (
                  <div
                    className="mx-2 spinner-border spinner-border-sm"
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SaveChapterPopup;
